/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
				Handlebars.registerHelper('times', function(n, block) {
					var accum = '';
					for(var i = 0; i < n; ++i) {
						accum += block.fn(i);
					}
					return accum;
				});
				Handlebars.registerHelper ('truncate', function (str, len) {
					if (str.length > len && str.length > 0) {
							var new_str = str + " ";
							new_str = str.substr (0, len);
							new_str = str.substr (0, new_str.lastIndexOf(" "));
							new_str = (new_str.length > 0) ? new_str : str.substr (0, len);
							return new Handlebars.SafeString ( new_str +'...' ); 
					}
					return str;
				});
				
				$(function() {
					$('.list-levels a').click(function(e) {
            e.preventDefault();
						var $self = $(this),
								$buyBtn = $('.btn-buy');
						$self.parents('.list-levels').find('a').removeClass('selected');
						$self.addClass('selected');
						if ( $buyBtn ) {
							$buyBtn.attr('href', $buyBtn.data('url') + '?level=' + $self.data('slug') );
						}
						$('.select-level').val($self.data('level-id')).change();

					}).filter('[data-level-id='+$('.select-level').val()+']').addClass('selected');
					
					$('body.page.home .list-levels a').click(function(e) {
						e.preventDefault();
						var $self = $(this),
								$buyBtn = $('.btn-buy');
						location.href = $buyBtn.attr('href');
          });
					
					/*$('.list-levels a').click(function(e) {
            e.preventDefault();
						var $self = $(this);
						$self.parents('.list-levels').find('a').removeClass('selected');
						$self.addClass('selected');
						$('.select-level').val($self.data('level-id')).change();
          }).filter('[data-level-id='+$('.select-level').val()+']').addClass('selected');*/
					$('.select-frequency,.select-level').change(function(e) {
            $self = $(this);
            $select_level = $('.select-level');
            $select_frequency = $('.select-frequency');
            selectedFrequency =  $select_frequency.data('prev');
            frequency =  $select_frequency.find(':selected').val();
						$select_frequency.data('prev', frequency);
						if ( $self.hasClass('select-level') ) {
							amount = $select_level.find(':selected').attr('data-amount');
							//console.log(amount,shares_price,Math.ceil(amount/shares_price));
							$('input.input-shares').val(Math.ceil(amount/shares_price));
							if ( frequency === 'monthly' ) {
								amount = parseFloat(amount/12).toFixed(2);
							}
						} else {
							amount = $('input#amount').val();
							if ( frequency !== selectedFrequency ) {
								amount = parseFloat(frequency=='monthly'?amount/12:amount*12).toFixed(2);
							}
						}
            html_amount = Number(parseFloat(amount).toFixed(2)).toLocaleString();
            $('input#amount').val(parseInt(amount)).change();
					}).change();
					$('input#amount, input.input-shares').change(function(e) {
            $self = $(this);
						$select_amount = $('input#amount');
						$select_shares = $('input.input-shares');
            $select_level = $('.select-level');
            $select_frequency = $('.select-frequency');

						if ( $self.hasClass('input-shares') ) {
							shares = parseInt($select_shares.val());
							
							level = 0;
							$('.select-level option').each(function(i,e){
								if ( shares >= parseInt($(e).attr('data-shares')) ) {
									level = $(e).val();
								}
							});
							amount = shares * shares_price;
							if ( frequency === 'monthly' ) {
								//amount = amount/12;
							}

						} else {
							amount = parseInt($select_amount.val());
							if ( frequency === 'monthly' ) {
								amount = amount*12;
							}
							
							level = 0;
							$('.select-level option').each(function(i,e){
								if ( amount >= parseInt($(e).attr('data-amount')) ) {
									level = $(e).val();
								}
							});
							
						}
						$('.select-level').val(level);
						$('.list-levels a').removeClass('selected')
							.filter('[data-level-id='+level+']').addClass('selected');
							
						total_shares = Math.ceil(amount/shares_price);
							
            frequency =  $select_frequency.find(':selected').val();
            frequency_name = '';
            html_amount = Number(parseInt(amount).toFixed(2)).toLocaleString();
            if ( frequency === 'monthly' ) {
              html_amount = Number(parseInt(amount/12).toFixed(2)).toLocaleString();
              amount = parseFloat(amount/12).toFixed(2);
            }
						frequency_name = frequency;
            
            html = 'Your card will be charged ' + shares_currency_symbol + html_amount + ' ' + frequency_name + '.';
            $('.amount-hint').text(html);
            $select_amount.val(parseInt(amount));
						
            //html = 'Total Shares: ' + total_shares;
            //$('.shares-hint').text(html);
            $select_shares.val(total_shares);
						
					}).change().keydown(function (e) {
						// Allow: backspace, delete, tab, escape, enter and .
						if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, /*110, 190*/]) !== -1 ||
							 // Allow: Ctrl+A
							(e.keyCode === 65 && e.ctrlKey === true) ||
							 // Allow: Ctrl+C
							(e.keyCode === 67 && e.ctrlKey === true) ||
							 // Allow: Ctrl+X
							(e.keyCode === 88 && e.ctrlKey === true) ||
							 // Allow: home, end, left, right
							(e.keyCode >= 35 && e.keyCode <= 39)) {
									 // let it happen, don't do anything
									 return;
						}
						// Ensure that it is a number and stop the keypress
						if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
							e.preventDefault();
						}
					});

				});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
				var roi_bucket;
								
				function rois_show(qty) {
					var source   = $('#roi-template').html();
					var template = Handlebars.compile(source);
					roi_new = roi_bucket.splice(0, roi_limit===-1?999:roi_limit);
					$('.list-rois .more').before(template(roi_new));
					if ( roi_bucket.length === 0 ) {
						$('.list-rois .more').hide();
					}
				}
				
				function roi_send(data) {
					$('#modal-roi-add').modal('show').find('.modal-content').html('<h3 class="text-center">Loading</h3>');
					$.ajax({
						url: spot_cs.ajax_url,
						type: 'post',
						data: data,
						async: false,
						cache: false,
						contentType: false,
						processData: false,
						success: function(response) {
							$('.modal-content','#modal-roi-add').html(response);
						}
					});
				}
								
				$(function(){
					if (typeof shareholder_json !== 'undefined') {
						var shareholders_source   = $('#shareholder-template').html();
						var shareholders_template = Handlebars.compile(shareholders_source);
						$('.list-shareholders').html(shareholders_template(shareholder_json));
						
						$('.list-shareholders a').click(function(e){
							e.preventDefault();
							var $self = $(this);
							var $shareholder = $self.parents('.shareholder');
							var shareholder = shareholder_json[$shareholder.data('level')].items[$shareholder.data('slug')];
							var shareholder_source   = $('#shareholder-modal-template').html();
							var shareholder_template = Handlebars.compile(shareholder_source);
							$('#modal-shareholder').find('.modal-content').html(shareholder_template(shareholder)).end().modal('show');
						});
					}
          
					if (typeof roi_json !== 'undefined') {
						roi_bucket = Object.keys(roi_json.rois).map(function (key) {return roi_json.rois[key];});
						rois_show(roi_limit);
						
						$(document).on('click','.list-rois .roi a', function(e){
							e.preventDefault();
							var $self = $(this);
							var $roi = $self.parents('.roi');
							var roi = roi_json.rois[$roi.data('slug')];
							var source   = $('#roi-modal-template').html();
							var template = Handlebars.compile(source);
							$('#modal-roi').find('.modal-content').html(template(roi)).end().modal('show');
						});
						$('.list-rois .more a').click(function(e){
							e.preventDefault();
							rois_show(roi_limit);
						});
					}
					
					$(document).on('click', '.btn-message', function(e){
						e.preventDefault();
						var $self = $(this),
								message_type = $self.data('message-type');
						$('.message-container').show().find('.message-type').hide().filter('.message-'+message_type).show();
					});

					$(document).on('click', '.btn-message-send', function(e){
						e.preventDefault();
						var $self = $(this),
								shareholder_slug = $self.data('shareholder-slug'),
								message_type = $self.data('message-type');
						$self.prop('disabled',true);
						$.ajax({
							url : spot_cs.ajax_url,
							type : 'post',
							data : {
								action : 'contact_shareholder',
								shareholder_slug : shareholder_slug,
								message_type : message_type
							},
							success : function( response ) {
								$self.removeProp('disabled').parents('.message-container').hide()
									.siblings('.message-sent-success').show();
							}
						});					
					});		
					
					
					$('.btn-roi-form-get').click(function(e) {
						e.preventDefault();
						var data = new FormData();
						//data = new FormData( 'action', 'roi_form_get' );
						//data = [{ name: 'get', value: true }, { name: 'action', value: 'roi_form_get' }];
						//data['action'] = 'roi_form_get';
						//data['get'] = true;
						data.append('action', 'roi_form_get');
						roi_send(data);
					});
					$(document).on('submit', '#modal-roi-add form', function(e) {
						e.preventDefault();
						var data = new FormData($(this)[0]);
						data.append('action', 'roi_form_get');
						//data = $(this).serializeArray();
						//console.log(data);
						//data.push({ name: 'action', value: 'roi_form_get' });
						//data = $(this).get(0);
						roi_send(data);
					});

					if ( typeof tickerSpeed !== 'undefined' ) {
						$('.bxslider').bxSlider({
							slideWidth: 'auto',
							slideMargin: 80,
							ticker: true,
							speed: tickerSpeed
						});
					};
				});

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'buyshares': {
      init: function() {
				// override jquery validate plugin defaults
				$.validator.setDefaults({
						errorElement: "span",
						errorClass: "invalid-feedback",
						highlight: function (element, errorClass, validClass) {
								$(element).addClass('is-invalid');
						},
						unhighlight: function (element, errorClass, validClass) {
								$(element).removeClass('is-invalid');
						},
						errorPlacement: function (error, element) {
								if (element.parent('.input-group').length || element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
										error.insertAfter(element.parent());
								} else {
										error.insertAfter(element);
								}
						}
				});
				
				function formatCurrency(num) {
						num = isNaN(num) || num === '' || num === null ? 0.00 : num;
						return parseFloat(num).toFixed(2);
				}
  
        /*Number.prototype.formatMoney = function(c, d, t){
          var n = this, 
          c = isNaN(c = Math.abs(c)) ? 2 : c, 
          d = d == undefined ? "." : d, 
          t = t == undefined ? "," : t, 
          s = n < 0 ? "-" : "", 
          i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", 
          j = (j = i.length) > 3 ? j % 3 : 0;
          return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        };*/
				
				function stripeResponseHandler(status, response) {
				  var $form = $('.form-buy');
				
				  if (response.error) {
						$form.find('.messages').append('<div class="alert alert-danger errors"><ul>'+response.error.message+'</ul></div>');
						$('html,body').animate({
							scrollTop: $form.find('.messages').offset().top - 15
						}, 1000);
						$form.find('.btn.submit').prop('disabled', false); // Re-enable submission
				  } else {
						var token = response.id;
						$form.append($('<input type="hidden" name="stripeToken" />').val(token));
						$('input[name=cc_num]').val('●●●● '+response.card.last4);
						$('input[name=cc_cvv]').val('●●●');
						$form.get(0).submit();
				  }
				}
                  
				$(function() {
					
          $('input[name=state]').blur(function(e) {
            var $self = $(this);
						if ( $self.val().length === 2 ) { $self.val( $self.val().toUpperCase() ); }
					});
          
          //$('#citizen_bio').characterCounter( { limit: 150, customFields: { 'class': 'help-block small' }, counterFormat: '%1 characters remaining.', counterExceededCssClass: 'exceeded text-danger' } );
          
          
          $('.select-method').change(function(e) {
						$('.payment-method').hide().filter('[data-method='+$(this).val()+']').show();
            if ($('.select-method').val() !== "cc"){
              $('.payment-method #cc_num').removeAttr('required');
              $('.payment-method .select-frequency').val('annually').change();
            } else {
              $('.payment-method #cc_num, .payment-method #amount').attr('required', 'required');
            }
					}).change();

          if ($('.select-method').val() !== "cc"){
            $('.payment-method #cc_num, .payment-method #amount').removeAttr('required');
          }

          /*function is_married(){
            if (jQuery('#shareholder_relationship_status').val() === 'Married'){
              jQuery('.married-questions').show();
            } else {
              jQuery('.married-questions').hide();
            }
          }
          is_married();
          $('#shareholder_relationship_status').change(function(){is_married();});*/
					
					$('.form-buy').validate({
						submitHandler: function(form) {
							var $self = $(form);
							$self.find('.btn.submit').prop('disabled',true);
							$('.alert.errors').remove();
							if ( $('.select-method').val() === 'cc' ) {
								//e.preventDefault();
							
								if ( $('input[name=stripeToken]').length ) {
									$self.get(0).submit();
								} else {
									Stripe.card.createToken({
										number: $('input[name=cc_num]').val(),
										cvc: $('input[name=cc_cvv]').val(),
										exp_month: $('[name=cc_exp_month]').val(),
										exp_year: $('[name=cc_exp_year]').val(),
										address_zip: $('[name=zip]').val()
									}, stripeResponseHandler);
								}
							} else {
								$self.get(0).submit();
							}
							
						}
					});
					
					$('input[name=cc_num], input[name=cc_cvv], [name=cc_exp_month], [name=cc_exp_year]').change(function(e) {
						$('input[name=stripeToken').remove();
					});
				
          
          
				});
				
      }
    },
    'myaccount': {
      init: function() {
				function stripeResponseHandler(status, response) {
					var $form = $('.form-add');
					if (response.error) {
						$form.find('.messages').append('<div class="alert alert-danger errors"><ul>'+response.error.message+'</ul></div>');
						$form.find('.submit').prop('disabled', false); // Re-enable submission
					} else { // Token was created!
						var token = response.id;
						$form.append($('<input type="hidden" name="stripeToken" />').val(token));
						$form.get(0).submit();
					}
				}
				
				$(function() {
					var $form = $('.form-add');
					$form.submit(function(e) {
						e.preventDefault();
						$form.find('.messages').empty();
						$form.find('.submit').prop('disabled', true);
						Stripe.card.createToken($form, stripeResponseHandler);
					});
				});
				
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
